import { render, staticRenderFns } from "./notificationPaneTitle.vue?vue&type=template&id=1972ad47&scoped=true"
import script from "./notificationPaneTitle.vue?vue&type=script&lang=js"
export * from "./notificationPaneTitle.vue?vue&type=script&lang=js"
import style0 from "./notificationPaneTitle.vue?vue&type=style&index=0&id=1972ad47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972ad47",
  null
  
)

export default component.exports